var map = {
	"./mobile/block.vue": [
		"0a2f",
		"chunk-793d4533",
		"chunk-88a0898c"
	],
	"./pc/block.vue": [
		"7174",
		"chunk-793d4533",
		"chunk-22ea92bc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ffae";
module.exports = webpackAsyncContext;